import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { getJobBoardUrl } from "../../util/talent-happy-path-util";

@Component({
    selector: 'app-location-mismatch-modal',
    imports: [
        TranslateModule,
        CdkTrapFocus
    ],
    templateUrl: './location-mismatch-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['../logout-confirmation-modal/logout-confirmation-modal.component.scss', './location-mismatch-modal.component.scss']
})

export class LocationMismatchModalComponent implements OnChanges {

  jobBoardUrl: string = getJobBoardUrl(null);
  @Input() countryId: number;

  @Output() continue = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges) {
    this.jobBoardUrl = getJobBoardUrl(this.countryId);
  }

  onContinue() {
    this.continue.emit();
  }

}
